<template>
    <div class="home_logged">
        <app-header></app-header>
        <main class="home_main" >
            <admin-home></admin-home>
        </main>
        <!-- <main class="" v-if="['crew'].includes(role)">
            <crew-home></crew-home>
        </main> -->
    </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AdminHome from '@/components/AdminHome.vue';
// import CrewHome from '@/components/CrewHome.vue';

import { mapState } from 'vuex';

export default {
    name: 'HomeLogged',
    components: {
        AppHeader,
        AdminHome
    },
    computed: {
        ...mapState([
            'role'
        ]),
    }
}
</script>

<style scoped>

    .home_main{
        padding: 50px 10px;
    }
</style>